import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RoleRouter } from './components/RoleRouter';
import { Landing } from './pages/Landing';
import { ExperimentPage } from './pages/ExperimentPage';
import { ExperimentList } from './pages/ExperimentList';
import { AssignmentBuilder } from './pages/teacher/AssignmentBuilder';
import { SignIn } from './pages/auth/SignIn';
import { SignUp } from './pages/auth/SignUp';
import { Curriculum } from './pages/Curriculum';
import { Subjects } from './pages/Subjects';
import { SubjectDetail } from './pages/SubjectDetail';
import { Tools } from './pages/Tools';
import { Research } from './pages/Research';
import { About } from './pages/About';
import { Philosophy } from './pages/Philosophy';
import { Documentation } from './pages/Documentation';
import { Contact } from './pages/Contact';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      {/* Aliases for common auth routes */}
      <Route path="/login" element={<Navigate to="/sign-in" replace />} />
      <Route path="/signup" element={<Navigate to="/sign-up" replace />} />

      {/* Landing Page */}
      <Route path="/" element={<Landing />} />

      {/* Public Pages */}
      <Route path="/curriculum" element={<Curriculum />} />
      <Route path="/subjects" element={<Subjects />} />
      <Route path="/subjects/:subject" element={<SubjectDetail />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/research" element={<Research />} />
      <Route path="/about" element={<About />} />
      <Route path="/philosophy" element={<Philosophy />} />
      <Route path="/documentation" element={<Documentation />} />
      <Route path="/contact" element={<Contact />} />

      {/* Protected Routes - require authentication */}
      <Route element={<ProtectedRoute />}>
        <Route path="/experiments" element={<ExperimentList />} />
        <Route path="/experiments/:domain/:slug" element={<ExperimentPage />} />
      </Route>

      {/* Main Application - Role-based dashboard routing */}
      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<RoleRouter />} />
      </Route>

      {/* Teacher Routes - require teacher role or higher */}
      <Route element={<ProtectedRoute requireRole="teacher" />}>
        <Route path="teacher/assignments/new" element={<AssignmentBuilder />} />
      </Route>

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
